
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import SbInsertStep from "@/components/stead/workspaces/stepbuilder/sbInsertStep.vue";
import SbDetails from "@/components/stead/workspaces/stepbuilder/sbDetails.vue";
import {TObjectDocument} from "@/models/tobject.model";
import {StepLightDocument} from "@/models/step.model";
import SbRunner from "@/components/stead/workspaces/stepbuilder/sbRunner.vue";
import {ajustHeight} from '@/shared/dom.utils';
import {onlineHelp} from "@/configs/onlineHelp";


@Component({
  components: {SbRunner, SbDetails, SbInsertStep}
})
export default class sbStepFile extends Vue {
  // Les props
  @Prop({default: null}) private insertData!: { pos: number, tobj: TObjectDocument } | null
  @Prop({default: null}) private tcid!: string | null
  @Prop({default: null}) private cursorStep!: StepLightDocument | null
  @Prop({default: -1}) private stepCursor!: number
  @Prop({default: false}) private isConnected!: boolean

  // Les propriétés
  private tab: number = 0
  private height: number = 400

  // Les propriétés calculées
  private get toolbarColor() {
    return this.theme.tree.doc1
  }

  private get theme() {
    return this.$store.state.testcase.theme
  }

  private get links() {
    return onlineHelp.stepbuilder
  }

  // Les hooks
  public mounted() {
    window.addEventListener('resize', this.ajustHeight)
    this.$nextTick(this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  @Watch('stepCursor')
  private onChangeStepCursor(newcursor: number, oldcursor: number) {
    if (oldcursor === -1 && newcursor !== -1) {
      this.tab = 1
    }
  }

  @Watch('isConnected')
  private onChangeMode() {
    if (this.stepCursor < 0) {
      this.stepCursor = 0
    }
    this.tab = this.isConnected ? 2 : 1
  }

  // Les méthodes d'instance
  private ajustHeight() {
    this.height = ajustHeight('sbstepfile', 64)
  }

  // Les méthodes statiques
}
